import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { payoutRequestErrorMessage } from "./payoutRequestError";

interface CreateExpertPayoutRequestInput {
  actingOrgId: number;
  amountCents: number;
  notes?: string | null;
}

export function useCreateExpertPayoutRequest() {
  const api = useApi();
  const toaster = useToaster();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["expert", "wallet", "createPayoutRequest"],
    mutationFn: async ({ actingOrgId, amountCents, notes }: CreateExpertPayoutRequestInput) => {
      return await api.expert.wallet.createPayoutRequest({
        body: {
          acting_org_id: actingOrgId,
          amount_cents: amountCents,
          notes: notes ?? null,
        },
      });
    },
    onSuccess: (_payoutRequest, variables) => {
      toaster.create({ title: "Payout request submitted successfully", type: "success" });
      queryClient.invalidateQueries({ queryKey: ["expert", "wallet", variables.actingOrgId, "payout-requests"] });
    },
    onError: (error: Error, variables) => {
      toaster.create({ title: `Failed to submit payout request: ${payoutRequestErrorMessage(error)}`, type: "error" });
      queryClient.invalidateQueries({ queryKey: ["expert", "wallet", variables.actingOrgId] });
    },
  });
}
